export default "__VITE_ASSET__51e8d5fe__"